import { render, staticRenderFns } from "./PremadePlanIndex.vue?vue&type=template&id=14c723d5"
import script from "./PremadePlanIndex.vue?vue&type=script&lang=ts"
export * from "./PremadePlanIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports